import { Box, BoxProps, Text } from '@chakra-ui/react'
import { FaCheck, FaRegClock } from 'react-icons/fa6'

interface iTagStatusProps extends BoxProps {
  status: number
}

export const TagStatus: React.FC<iTagStatusProps> = ({ status, ...rest }) => {
  const titulo = status === 0 ? 'Em andamento' : 'Finalizado'
  const cor = status === 0 ? 'var(--Azul)' : 'var(--Green2)'
  const Icone = status === 0 ? FaRegClock : FaCheck

  return (
    <Box
      display={'flex'}
      bgColor={cor}
      color={'var(--c1)'}
      px={'.5rem'}
      py={'.125rem'}
      borderRadius={'.75rem'}
      gap={'.25rem'}
      width={'fit-content'}
      alignItems={'center'}
      {...rest}
    >
      <Icone size={11} />
      <Text fontSize={'.75rem'} fontWeight={500} whiteSpace={'nowrap'}>{titulo}</Text>
    </Box>
  )
}
